module.exports = "<p>\r\n  reportes works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/reportes/reportes.component.html
// module id = ../../../../../src/app/components/reportes/reportes.component.html
// module chunks = main